import { MessageBox } from 'element-ui'
// import {apiUserLogin, getUserInfo, apiIndexGet} from '@/api/api'
import { getToken, setToken, removeToken } from '@/api/auth'
import store from '@/store/index'

const user = {
  state: {
    user: '',
    user_info: '',
    site: "",
    config: "",
    manystore: "",
    copyright_lst: [],
    advert: null

  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_USER_INFO: (state, user) => {
      state.user_info = user
    },
    SET_SITE: (state, site) => {
      state.site = site
    },
    SET_CONFIG: (state, config) => {
      state.config = config
    },
  },

  actions: {
    // 登陆
    loginBy({ commit }, user_info) {
      const data = {
        mobile: user_info.mobile.trim(),
        password: user_info.password
      }
      return new Promise((resolve, reject) => {
        apiUserLogin(data).then(res => {
          if (res.code === 1) {
            var user = res.data.userinfo
            setToken(user.token)
            commit('SET_TOKEN', user.token)
            commit('SET_USER', user)
            localStorage.setItem('USERINFO', JSON.stringify(user))
            resolve(res.msg)
          } else {
            reject(res)
          }
        })
      })
    },
    GetUserInfo({ commit, state }) {
      getUserInfo().then(res => {
        const data = res.data
        commit('SET_USER', data.user)
      }).catch(error => {

      })
    },
    getIndexConfig({ commit, state }){
      apiIndexGet({style_name: "style2"}).then(res => {
        state.copyright_lst = res.data.copyright_lst;
        state.manystore = res.data.manystore;
        let advert = {};
        if(res.data.manystore.ads){
          for(let i in res.data.manystore.ads.images){
            advert[i] = res.data.manystore.ads.images[i];
          }
        }
        state.advert = advert;

        commit('SET_SITE', res.data.site);
        commit("SET_CONFIG", res.data);
        commit("SET_USER_INFO", res.data.user);
        localStorage.setItem("advertConfig", JSON.stringify(state.advert));
        localStorage.setItem("config", res.data)
      })
    },
    // 前端 登出
    FedLogOut({ commit, state }) {
      localStorage.removeItem('USERINFO')
      commit('SET_TOKEN', '')
      commit('SET_USER', '')
      commit('SET_USER_INFO', '')
      // removeToken();
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js